<template>
  <el-container id="app">
    <el-header height="">
      <img src="~assets/logo.svg" alt="" style="width: 350px; height: 110px;">
    </el-header>

    <el-main>
      <div class="app-wrap">
        <div class="app-steps" v-if="currentStep >= 0">
          <div class="app-container">
            <el-steps :active="currentStep" finish-status="success">
              <el-step v-for="step in steps" :key="step.name" :title="step.name" @click.native="goToPath(step.path)" />
            </el-steps>
          </div>
        </div>

        <div class="app-body">
          <div class="app-container">
            <div class="app-content">
              <el-collapse-transition>
                <router-view />
              </el-collapse-transition>
            </div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import 'styles/element-ui.scss';
  import 'styles/app.scss';

  import findIndex from 'lodash/findIndex';
  import eventBus from './eventBus';

  export default {
    name: 'app',
    computed: {
      steps() {
        return [
          { name: 'Campus', path: '/campus' },
          { name: 'Your Info', path: '/info' },
          { name: 'Spiritual Gifts', path: '/gifts' },
          { name: 'Heart', path: '/heart' },
          { name: 'Abilities', path: '/abilities' },
          { name: 'Personality', path: '/personality' },
          { name: 'Experience', path: '/experience' },
          { name: 'Results', path: '/results' },
        ];
      },
      currentStep() {
        return findIndex(this.steps, step => step.path === this.$route.path);
      },
    },
    methods: {
      goToPath(path) {
        eventBus.$emit('go-to-step', { path });
      },
    },
  };
</script>

<style lang="scss">
  @import "~styles/vars";
  @import "~element-theme/mixins/mixins.scss";

  .app-steps {
    background: url('~assets/crossword.png') repeat;
    display: none;
    margin-bottom: 3rem;
    padding: 2rem 0;
    @include res(md) {
      display: block;
    }
  }

  .app-content {
    max-width: 900px;
    padding-bottom: 10rem;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue